import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { PostingLineDisplayStatus } from '@/utils/PostingLog/types';
import { STATUS_CONFIG } from '@/utils/PostingLog/constants';

export const StatusBadge: React.FC<{ status: PostingLineDisplayStatus }> = ({ status }) => (
  <Badge className={cn('text-xs font-medium', STATUS_CONFIG[status].badgeClass)}>{status}</Badge>
);
